// import React from "react";
// import copyright from "../../../assets/logo/payment-method.png";

// interface CopyrightComponentProps {}

// export const CopyrightComponent: React.FC<CopyrightComponentProps> = (
//   props: CopyrightComponentProps
// ) => {
//   const today = new Date();
//   const year = today.getFullYear();

//   return (
//     <div className="bg-gray-800 py-4">
//       <div className="container md:flex md:items-center md:justify-between">
//         <img src={copyright} className="h-5" alt="copyrightImage" />
//         <p className="mt-2 text-white md:mt-0 lg:mt-0">
//           &copy; {year} Eshoppers - All Right Reserved.
//         </p>
//         <p className="mt-2 text-white md:mt-0 lg:mt-0">
//           Designed by Samiul Sheikh
//         </p>
//       </div>
//     </div>
//   );
// };
import React from "react";
import copyright from "../../../assets/logo/payment-method.png";

interface CopyrightComponentProps {}

export const CopyrightComponent: React.FC<CopyrightComponentProps> = () => {
  const year = new Date().getFullYear();

  return (
    <div className="bg-gray-800 py-4">
      <div className="container md:flex md:items-center md:justify-between text-center md:text-left">
        <img
          src={copyright}
          className="h-5 mx-auto md:mx-0"
          alt="payment methods"
        />

        <p className="mt-2 text-white md:mt-0">
          &copy; {year} Eshoppers — All Rights Reserved.
        </p>

        <p className="mt-2 text-white md:mt-0">
          Designed by{" "}
          <a
            href="https://samiul-sheikh.vercel.app/"
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-400 hover:text-blue-300 transition-colors font-medium"
          >
            Samiul Sheikh
          </a>
        </p>
      </div>
    </div>
  );
};
